<template>
  <div>
    <v-snackbar class="pt-6 pr-6" style="z-index: 6 !important" transition="slide-x-reverse-transition"
      v-model="snackbar" timeout="2000" :value="true" :color="snaclr" absolute outlined top right>
      <v-icon class="mr-2" :color="snaclr">mdi-alert-outline</v-icon>
      {{ errMsg }}
    </v-snackbar>
    <v-app-bar :dark="$vuetify.theme.dark"
      :style="{ 'border-bottom': $vuetify.theme.dark ? '1px soild white' : '1px solid #e0e0e0', backgroundColor: $vuetify.theme.dark ? '#121212' : 'white' }"
      elevation="0" app height="50px" fixed class="pa-0">
      <div>
        <p class="font-weight-bold mb-0 ml-5 black--text" style="font-size: 25px;font-weight: 900 !important">
        GUIDESK</p>

      </div>
      <v-spacer></v-spacer>
    </v-app-bar>
    <div class="ml-14 mr-14 mt-2">
      <v-card elevation="0" outlined class=" pa-1">
        <div class="d-flex">
                        <p class="mt-7 mb-1 ml-4 title font-weight-bold">Guidesk Leads Data</p>
                      
                        <div class="ml-auto">
                            <v-text-field prepend-inner-icon="mdi-magnify" placeholder="Serach" height="40px" dense
                                background-color="#F1F3F8" flat class="ml-auto  rounded-pill mt-7 mr-8" solo hide-details
                                hide-spin-buttons v-model="tabledata">

                            </v-text-field>
                        </div>

                    </div>
        <v-data-table :search="tabledata" :loading="tableload" :headers="headers" :items="dispayadmindat"
          class="elevation-0 mt-1" disable-sort outlined>
        </v-data-table>
      </v-card>
    </div>
  </div>
</template>


<script>
export default {
  data() {
    return {

      tabledata: "",
      headers: [
        {
          text: 'Date & Time',
          align: 'start',
          value: 'reg_date',
        },
        { text: 'Name', value: 'name' },
        { text: 'Email Id', value: 'email' },
        { text: 'Mobile Number', value: 'mobilenumber' },
        { text: 'Query', value: 'query' },
        // { text: 'Qty', value: 'qty' },
      ],
      dispayadmindat: [],
      snackbar: false,
      errMsg: "",
      snaclr: "#000",
      tableload: true
    }

  },
  methods: {
    lumsunresdata() {
      this.tableload = true
      this.dispayadmindat = []
      const axios = require('axios');
    

      let config = {
  method: 'post',
  maxBodyLength: Infinity,
  url: 'https://dwld.zebuetrade.com/view_guidesk_quries',
  headers: { }
};

      var axiosThis = this
      axios.request(config)
        .then((response) => {
          axiosThis.tableload = false
          if (response.data.stat == "Ok") {
            axiosThis.dispayadmindat = response.data.data
          } else {
            axiosThis.snackbar = true
            axiosThis.errMsg = response.data
            axiosThis.snaclr = "error"
          }
        })
        .catch((error) => {
          console.log(error);
          axiosThis.tableload = false
          axiosThis.snackbar = true
          axiosThis.errMsg = error
          axiosThis.snaclr = "error"
        });

    }
  },
  mounted() {
    this.lumsunresdata()
  }
}
</script>